import { format } from 'date-fns'

export const formatDateForContracts = (date: any, formatDate: string) => {
  const formatedDate = format(date, formatDate)
  return formatedDate
}

export const formatDateShippingFromExpiration = (
  date: any,
  formatDate: string
) => {
  const formatedDate = format(date, formatDate)
  return `${formatedDate} 00:00:00`
}

export const formatStringDateType = (
  date: string | Date,
  formatDate: string
) => {
  return format(new Date(date), formatDate)
}

export function formatDate(date?: string | Date): string {
  if (!date) {
    return ''
  }
  if (date instanceof Date) {
    return date.toISOString().split('T')[0].split('-').reverse().join('/')
  }
  return date.split('T')[0].split('-').reverse().join('/')
}

export const formatDateShort = (date?: string | Date): string => {
  if (!date) return ''

  const d = typeof date === 'string' ? new Date(date) : date

  const months = [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
  ]

  const day = String(d.getDate()).padStart(2, '0')
  const month = months[d.getMonth()]
  const year = d.getFullYear()

  return `${day} ${month} ${year}`
}
